const AccessTokenManager = (() => {
    let accessToken: string = "";
  
    const getAccessToken = (): string => accessToken;
  
    const setAccessToken = (token: string): void => {
      accessToken = token;
    };
  
    return {
      getAccessToken,
      setAccessToken,
    };
  })();
  
  export default AccessTokenManager;